import { Injectable, inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AzureAuthService, DtisAzureRoles } from '../azure-auth.service';

const guardRole = DtisAzureRoles.SUPER_USER;
const forbiddenRoute = '/forbidden';
@Injectable({
  providedIn: 'root',
})
export class SuperUserGuard {
  private readonly router = inject(Router);
  private readonly azure = inject(AzureAuthService);

  /**
   *
   * @param route
   * @param state
   * @returns
   */
  canActivateChild(): boolean {
    if (this.azure.hasRole(guardRole)) {
      return true;
    }

    this.router.navigate([forbiddenRoute]);
    return false;
  }
}

export function SuperUserGuardFn(): CanActivateFn {
  return () => {
    const router = inject(Router);
    const azure = inject(AzureAuthService);

    return azure.hasRole(guardRole) || router.parseUrl(forbiddenRoute);
  };
}
